import { Box } from "@chakra-ui/react"
import { AlgoliaIndexes, DomainObjects } from "projectlink-common"
import endpoints from "src/access/endpoints"
import FilterableSearchInput from "src/search/FilterableSearchInput"
import Hits from "src/search/Hits"
import SearchableFeedProvider from "src/search/SearchableFeedProvider"
import { H1 } from "src/typography/typography"
import { domainColor } from "src/util/style"
import useSWR from "swr"

function Projects({ initialTopics, initialHits }) {
  const { data: topics } = useSWR(endpoints.topics, {
    initialData: initialTopics,
  })

  return (
    <SearchableFeedProvider
      indexName={AlgoliaIndexes.projects}
      initialHits={initialHits}
    >
      <Box layerStyle='appContainer'>
        <H1
          maxW='container.md'
          mx='auto'
          my='base'
          color={domainColor(DomainObjects.project)}
        >
          Projects
        </H1>
        <FilterableSearchInput
          initialTopics={topics}
          hideTypes={true}
          mb='base'
        />
        <Hits />
      </Box>
    </SearchableFeedProvider>
  )
}

export default Projects
